import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, serviceQuoteLink } from "../../lib/site";

const ServiceCard = ({ service, index }) => (
    <motion.article
        data-testid={service.testid}
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
        className={`group relative min-h-[440px] overflow-hidden rounded-2xl border border-white/10 bg-card transition-colors duration-500 hover:border-magenta/60 ${service.span}`}
    >
        <img
            src={service.image}
            alt={service.title}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-60 grayscale contrast-125 transition-all duration-700 group-hover:scale-105 group-hover:opacity-90 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-magenta-deep/30 mix-blend-multiply transition-opacity duration-700 group-hover:opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-transparent" />

        <span className="absolute left-5 top-5 bg-magenta px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-white">
            {service.badge}
        </span>

        <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-tangerine">
                {service.tag}
            </span>
            <h3 className="mt-2 font-display text-3xl font-bold uppercase italic text-mist md:text-4xl">
                {service.title}
            </h3>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-mist/70">
                {service.description}
            </p>
            <a
                href={serviceQuoteLink(service.title)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${service.testid}-quote-link`}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-mist transition-colors duration-300 hover:text-tangerine"
            >
                Cotar este serviço
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
        </div>
    </motion.article>
);

export const Services = () => (
    <section
        id="servicos"
        data-testid="services-bento-section"
        className="relative py-24 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <div className="mb-14 flex flex-col gap-6 lg:mb-16 lg:flex-row lg:items-end lg:justify-between">
                <div>
                    <motion.span
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.15 }}
                        transition={{ duration: 0.5 }}
                        className="font-mono text-[11px] uppercase tracking-[0.35em] text-tangerine"
                    >
                        // O que fazemos
                    </motion.span>
                    <motion.h2
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.15 }}
                        transition={{ duration: 0.6, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
                        className="mt-4 font-display text-4xl font-extrabold uppercase italic leading-none text-mist sm:text-6xl"
                    >
                        Nossos <span className="text-magenta">serviços</span>
                    </motion.h2>
                </div>
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 0.6, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
                    className="max-w-md text-base leading-relaxed text-mute"
                >
                    Da coleta à última milha, a Borges Cargas cuida da sua carga
                    com precisão, segurança e prazo cumprido.
                </motion.p>
            </div>

            <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
                {SERVICES.map((service, i) => (
                    <ServiceCard key={service.id} service={service} index={i} />
                ))}
            </div>
        </div>
    </section>
);
